import axios from 'axios';

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true,
});

api.interceptors.response.use(
    response => response,
    error => {
        if (
            error.response &&
            error.response.status === 401 &&
            error.response.data?.loginUrl
        ) {

            const currentUrl = window.location.href;

            localStorage.setItem('redirectAfterLogin', currentUrl);

            const loginUrl = error.response.data.loginUrl + "&state=" + encodeURIComponent(currentUrl);
            window.location.href = loginUrl;

            return;
        }

        return Promise.reject(error);
    }
);

export default api;
